enum INPATIENT_ACTION_TYPE {
    NORMAL = 0,
    RELOAD = 1,
    CLEAR = 2,
    EDIT = 3
}

export {INPATIENT_ACTION_TYPE};